import { render, staticRenderFns } from "./RenovationFilter.vue?vue&type=template&id=392064a3&"
import script from "./RenovationFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RenovationFilter.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports